import { Component, Input, OnInit } from '@angular/core';
import { ModuleManager } from 'src/shared/models/module-manager';

@Component({
    selector: 'cv-contact-list-settings',
    templateUrl: './contact-list-settings.component.html',
    styleUrls: ['./contact-list-settings.component.scss']
})
export class ContactListSettingsComponent implements OnInit {
    @Input() moduleManager: ModuleManager;

    constructor() { }

    ngOnInit() {
        this.moduleManager.customSettingsAdded = true;
    }
}
